const getUrlQuery = () => {
  const queries = {};
  if (typeof window !== 'undefined') {
    window.location.search
      .slice(1)
      .split('&')
      .forEach((queryItem) => {
        const [key, value] = queryItem.split('=');
        queries[key] = value;
      });
  }
  return queries;
};

export default getUrlQuery;
